import { Form, Select } from 'antd';
import React, { useEffect } from 'react';

const ColorDropdown = ({
    name,
    label,
    form,
    defaultValue,
    placeholder,
    disabled,
    labelSpan,
    labelCol,
    required,
    options,
    multiSelect,
    errorMessage,
    searchable
}) => {

    useEffect(() => {
        if (defaultValue) {
            form.setFieldValue(name, defaultValue);
        }
    }, []);

    return (
        <Form.Item
            name={name}
            wrapperCol={!label ? { span: 24 } : undefined}
            labelCol={{ span: labelCol || labelSpan || 8 }}
            label={label}
            placeholder={placeholder}
            rules={[{ required: required, message: errorMessage }]}
        >
            <Select
                disabled={disabled}
                placeholder={placeholder}
                optionLabelProp="label"
                showSearch={searchable ? searchable : false}
                mode={multiSelect ? 'multiple': undefined}
            >
                {
                    options.map((x, i) => (
                        <Select.Option key={`color_dropdown_${name}_${i}`} value={x.value} label={x.label}>
                            <div
                                style={{
                                    borderLeft: "5px solid",
                                    borderColor: x.colr,
                                    paddingLeft: "10px",
                                }}
                            >
                                {x.label}
                            </div>
                        </Select.Option>
                    ))
                }
            </Select>
        </Form.Item>
    )
};

export default ColorDropdown;